module.exports = __webpack_public_path__ + "static/media/power-search.0c449a78.png";